import { Dispatch } from 'redux'

export const NoActionThunk = () => async (_: Dispatch) => {
    // do nothing
}
